"use strict";exports.ARIA_LABEL={SAVINGS_MESSAGE:"savings-message"};
//# sourceMappingURL=index.js.map
